import { useEffect, useRef } from "react";
import DOMPurify from "dompurify";

export default function Signature({ signature, onChange, isReadOnly = false,  isBorderTop = false }: { signature?: string; onChange?: (html: string) => void, isReadOnly?: boolean, isBorderTop?:boolean }) {
    const editorRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (editorRef.current) {
            const safe = DOMPurify.sanitize(signature || "", { KEEP_CONTENT: true });
            editorRef.current.innerHTML = safe;
        }
    }, [signature]);

    const handlePaste = (e: any) => {
        e.preventDefault();
        const html = e.clipboardData.getData("text/html") || e.clipboardData.getData("text/plain") || "";
        const cleanHTML = DOMPurify.sanitize(html, { KEEP_CONTENT: true });
        if (editorRef.current) {
            editorRef.current.innerHTML = cleanHTML;
        }
        onChange?.(cleanHTML);
    };

    const handleInput = () => {
        if (editorRef.current) {
            const html = editorRef.current.innerHTML;
            onChange?.(html);
        }
    };
    return (
        <div className="p-6 space-y-4">
            <div
                contentEditable={!isReadOnly}
                ref={editorRef}
                onPaste={handlePaste}
                onInput={handleInput}
                className="form-control min-h-[150px] overflow-auto"
                style={{ borderTop: !isReadOnly || isBorderTop ? "1" : "0", whiteSpace: "pre-wrap", marginTop: isReadOnly ? "-8px" : "0", minHeight: isReadOnly ? "50px" : "150px" }}
            >
            </div>
        </div>
    );
}



